import { render, staticRenderFns } from "./HeaderSearchArea.vue?vue&type=template&id=220d0812&scoped=true&"
import script from "./HeaderSearchArea.vue?vue&type=script&lang=js&"
export * from "./HeaderSearchArea.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSearchArea.vue?vue&type=style&index=0&id=220d0812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d0812",
  null
  
)

export default component.exports